function cov_isg9tnn5j() {
  var path = "/app/src/context/store/store-reducer.tsx";
  var hash = "5429d75e05c20bf785654f4cac43495c285ca404";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/context/store/store-reducer.tsx",
    statementMap: {
      "0": {
        start: {
          line: 75,
          column: 59
        },
        end: {
          line: 198,
          column: 1
        }
      },
      "1": {
        start: {
          line: 76,
          column: 2
        },
        end: {
          line: 197,
          column: 3
        }
      },
      "2": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 84,
          column: 8
        }
      },
      "3": {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 94,
          column: 8
        }
      },
      "4": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 100,
          column: 8
        }
      },
      "5": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 106,
          column: 8
        }
      },
      "6": {
        start: {
          line: 115,
          column: 10
        },
        end: {
          line: 115,
          column: 24
        }
      },
      "7": {
        start: {
          line: 117,
          column: 28
        },
        end: {
          line: 120,
          column: 7
        }
      },
      "8": {
        start: {
          line: 122,
          column: 6
        },
        end: {
          line: 141,
          column: 8
        }
      },
      "9": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 147,
          column: 8
        }
      },
      "10": {
        start: {
          line: 150,
          column: 6
        },
        end: {
          line: 157,
          column: 8
        }
      },
      "11": {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 192,
          column: 8
        }
      },
      "12": {
        start: {
          line: 196,
          column: 6
        },
        end: {
          line: 196,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 75,
            column: 59
          },
          end: {
            line: 75,
            column: 60
          }
        },
        loc: {
          start: {
            line: 75,
            column: 78
          },
          end: {
            line: 198,
            column: 1
          }
        },
        line: 75
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 197,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 77,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }, {
          start: {
            line: 86,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }, {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 101,
            column: 5
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 107,
            column: 5
          }
        }, {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 142,
            column: 5
          }
        }, {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }, {
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        }, {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 193,
            column: 5
          }
        }, {
          start: {
            line: 195,
            column: 4
          },
          end: {
            line: 196,
            column: 19
          }
        }],
        line: 76
      },
      "1": {
        loc: {
          start: {
            line: 89,
            column: 21
          },
          end: {
            line: 89,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 21
          },
          end: {
            line: 89,
            column: 60
          }
        }, {
          start: {
            line: 89,
            column: 64
          },
          end: {
            line: 89,
            column: 66
          }
        }],
        line: 89
      },
      "2": {
        loc: {
          start: {
            line: 90,
            column: 18
          },
          end: {
            line: 90,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 18
          },
          end: {
            line: 90,
            column: 54
          }
        }, {
          start: {
            line: 90,
            column: 58
          },
          end: {
            line: 90,
            column: 60
          }
        }],
        line: 90
      },
      "3": {
        loc: {
          start: {
            line: 91,
            column: 13
          },
          end: {
            line: 91,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 13
          },
          end: {
            line: 91,
            column: 31
          }
        }, {
          start: {
            line: 91,
            column: 35
          },
          end: {
            line: 91,
            column: 37
          }
        }],
        line: 91
      },
      "4": {
        loc: {
          start: {
            line: 92,
            column: 16
          },
          end: {
            line: 92,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 92,
            column: 16
          },
          end: {
            line: 92,
            column: 37
          }
        }, {
          start: {
            line: 92,
            column: 41
          },
          end: {
            line: 92,
            column: 61
          }
        }],
        line: 92
      },
      "5": {
        loc: {
          start: {
            line: 131,
            column: 12
          },
          end: {
            line: 140,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 139,
            column: 13
          }
        }, {
          start: {
            line: 140,
            column: 12
          },
          end: {
            line: 140,
            column: 14
          }
        }],
        line: 131
      },
      "6": {
        loc: {
          start: {
            line: 163,
            column: 12
          },
          end: {
            line: 169,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 164,
            column: 12
          },
          end: {
            line: 168,
            column: 13
          }
        }, {
          start: {
            line: 169,
            column: 12
          },
          end: {
            line: 169,
            column: 14
          }
        }],
        line: 163
      },
      "7": {
        loc: {
          start: {
            line: 170,
            column: 12
          },
          end: {
            line: 174,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 171,
            column: 12
          },
          end: {
            line: 173,
            column: 13
          }
        }, {
          start: {
            line: 174,
            column: 12
          },
          end: {
            line: 174,
            column: 14
          }
        }],
        line: 170
      },
      "8": {
        loc: {
          start: {
            line: 175,
            column: 12
          },
          end: {
            line: 177,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 176,
            column: 12
          },
          end: {
            line: 176,
            column: 80
          }
        }, {
          start: {
            line: 177,
            column: 12
          },
          end: {
            line: 177,
            column: 14
          }
        }],
        line: 175
      },
      "9": {
        loc: {
          start: {
            line: 178,
            column: 12
          },
          end: {
            line: 185,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 179,
            column: 12
          },
          end: {
            line: 184,
            column: 13
          }
        }, {
          start: {
            line: 185,
            column: 12
          },
          end: {
            line: 185,
            column: 14
          }
        }],
        line: 178
      },
      "10": {
        loc: {
          start: {
            line: 181,
            column: 18
          },
          end: {
            line: 183,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 182,
            column: 18
          },
          end: {
            line: 182,
            column: 20
          }
        }, {
          start: {
            line: 183,
            column: 18
          },
          end: {
            line: 183,
            column: 52
          }
        }],
        line: 181
      },
      "11": {
        loc: {
          start: {
            line: 186,
            column: 12
          },
          end: {
            line: 191,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 187,
            column: 12
          },
          end: {
            line: 190,
            column: 13
          }
        }, {
          start: {
            line: 191,
            column: 12
          },
          end: {
            line: 191,
            column: 14
          }
        }],
        line: 186
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0, 0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5429d75e05c20bf785654f4cac43495c285ca404"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_isg9tnn5j = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_isg9tnn5j();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ACTIONS } from 'src/constants/common';
import { INSTALLMENTS_COUNT_DEFAULT } from 'src/context/store/app-provider';
import { checkCurrency, formatCurrency } from 'src/utils/check-currency';
import { checkInstallmentsCount } from 'src/utils/check-installments-count';
import { checkLang } from 'src/utils/check-lang';
import { checkLocale } from 'src/utils/check-locale';
import { checkPrice } from 'src/utils/check-price';
import { getLangAndLocale } from 'src/utils/get-lang-and-locale';
cov_isg9tnn5j().s[0]++;
export var storeReducer = function storeReducer(state, action) {
  cov_isg9tnn5j().f[0]++;
  cov_isg9tnn5j().s[1]++;
  switch (action.type) {
    case ACTIONS.SHOW_LEARN_MORE:
      cov_isg9tnn5j().b[0][0]++;
      {
        cov_isg9tnn5j().s[2]++;
        return _objectSpread(_objectSpread({}, state), {}, {
          learnMoreVisibility: _objectSpread(_objectSpread({}, state.learnMoreVisibility), action.payload)
        });
      }
    case ACTIONS.GET_WIDGET_DATA:
      cov_isg9tnn5j().b[0][1]++;
      {
        var _action$payload$exper, _action$payload$exper2;
        cov_isg9tnn5j().s[3]++;
        return _objectSpread(_objectSpread({}, state), {}, {
          experiments: (cov_isg9tnn5j().b[1][0]++, (_action$payload$exper = action.payload.experiments) === null || _action$payload$exper === void 0 ? void 0 : _action$payload$exper.experiments) || (cov_isg9tnn5j().b[1][1]++, []),
          entityId: (cov_isg9tnn5j().b[2][0]++, (_action$payload$exper2 = action.payload.experiments) === null || _action$payload$exper2 === void 0 ? void 0 : _action$payload$exper2.entityId) || (cov_isg9tnn5j().b[2][1]++, ''),
          aid: (cov_isg9tnn5j().b[3][0]++, action.payload.aid) || (cov_isg9tnn5j().b[3][1]++, ''),
          offers: (cov_isg9tnn5j().b[4][0]++, action.payload.offers) || (cov_isg9tnn5j().b[4][1]++, {
            installments: []
          }),
          loading: false
        });
      }
    case ACTIONS.PREPARE_PAY_IN_FULL_POPUP:
      cov_isg9tnn5j().b[0][2]++;
      {
        cov_isg9tnn5j().s[4]++;
        return _objectSpread(_objectSpread({}, state), {}, {
          isMobileRounded: true
        });
      }
    case ACTIONS.SET_TITLES:
      cov_isg9tnn5j().b[0][3]++;
      {
        cov_isg9tnn5j().s[5]++;
        return _objectSpread(_objectSpread({}, state), {}, {
          titles: action.payload
        });
      }
    case ACTIONS.UPDATE_FROM_DATASET:
      cov_isg9tnn5j().b[0][4]++;
      {
        var _ref = (cov_isg9tnn5j().s[6]++, action.payload),
          tabbyLanguage = _ref.tabbyLanguage,
          tabbyLocale = _ref.tabbyLocale,
          tabbyInstallmentsCount = _ref.tabbyInstallmentsCount,
          tabbyPrice = _ref.tabbyPrice,
          tabbyCurrency = _ref.tabbyCurrency;
        var langAndLocale = (cov_isg9tnn5j().s[7]++, getLangAndLocale(tabbyLanguage, tabbyLocale));
        cov_isg9tnn5j().s[8]++;
        return _objectSpread(_objectSpread({}, state), {}, {
          installmentsCount: checkInstallmentsCount(INSTALLMENTS_COUNT_DEFAULT)(tabbyInstallmentsCount),
          price: checkPrice(tabbyPrice),
          priceRaw: tabbyPrice,
          currency: checkCurrency(tabbyCurrency),
          formattedCurrency: tabbyCurrency
        }, langAndLocale ? (cov_isg9tnn5j().b[5][0]++, {
          lang: checkLang(langAndLocale.lang, {
            locale: langAndLocale.locale
          }),
          locale: checkLocale(langAndLocale.locale, {
            lang: langAndLocale.lang
          })
        }) : (cov_isg9tnn5j().b[5][1]++, {}));
      }
    case ACTIONS.PREPARE_ALSHAYA_LIMIT:
      cov_isg9tnn5j().b[0][5]++;
      {
        cov_isg9tnn5j().s[9]++;
        return _objectSpread(_objectSpread({}, state), {}, {
          isBig: true
        });
      }
    case ACTIONS.PREPARE_SCHEDULE_POPUP:
      cov_isg9tnn5j().b[0][6]++;
      {
        cov_isg9tnn5j().s[10]++;
        return _objectSpread(_objectSpread({}, state), {}, {
          isBig: true,
          isDark: true,
          isBold: true,
          isMobileRounded: true,
          isShortSplitIt: true
        });
      }
    case ACTIONS.UPDATE_STORE:
      cov_isg9tnn5j().b[0][7]++;
      {
        cov_isg9tnn5j().s[11]++;
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, state), action.payload), 'installmentsCount' in action.payload ? (cov_isg9tnn5j().b[6][0]++, {
          installmentsCount: checkInstallmentsCount(INSTALLMENTS_COUNT_DEFAULT)(action.payload.installmentsCount)
        }) : (cov_isg9tnn5j().b[6][1]++, {})), 'lang' in action.payload ? (cov_isg9tnn5j().b[7][0]++, {
          lang: checkLang(action.payload.lang, {
            locale: state.locale
          })
        }) : (cov_isg9tnn5j().b[7][1]++, {})), 'locale' in action.payload ? (cov_isg9tnn5j().b[8][0]++, {
          locale: checkLocale(action.payload.locale, {
            lang: state.lang
          })
        }) : (cov_isg9tnn5j().b[8][1]++, {})), 'price' in action.payload ? (cov_isg9tnn5j().b[9][0]++, _objectSpread({
          price: checkPrice(action.payload.price)
        }, action.payload.skipRawPriceUpdate ? (cov_isg9tnn5j().b[10][0]++, {}) : (cov_isg9tnn5j().b[10][1]++, {
          priceRaw: action.payload.price
        }))) : (cov_isg9tnn5j().b[9][1]++, {})), 'currency' in action.payload ? (cov_isg9tnn5j().b[11][0]++, {
          currency: checkCurrency(action.payload.currency),
          formattedCurrency: formatCurrency(action.payload.currency)
        }) : (cov_isg9tnn5j().b[11][1]++, {}));
      }
    default:
      cov_isg9tnn5j().b[0][8]++;
      cov_isg9tnn5j().s[12]++;
      return state;
  }
};